import { Box, Stack, Typography } from "@mui/material";
import {
	PARTNER_CALENDAR_STATUS_COLORS,
	PARTNER_CALENDAR_STATUS_LABELS,
	PartnerCalendarStatus,
} from "./types";

export function Legend() {
	return (
		<Stack direction="row" spacing={3}>
			{Object.values(PartnerCalendarStatus).map((status) => (
				<Stack key={status} direction="row" alignItems="center" spacing={1}>
					<Box
						sx={{
							width: 16,
							height: 16,
							bgcolor: PARTNER_CALENDAR_STATUS_COLORS[status],
							borderRadius: 0.5,
						}}
					/>
					<Typography variant="body2" color="text.secondary">
						{PARTNER_CALENDAR_STATUS_LABELS[status]}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
}
